document.addEventListener("DOMContentLoaded", function () {
    const mobileMapSection = document.querySelectorAll('.order-mobile__map-section')

    if(mobileMapSection.length){
        mobileMapSection.forEach((mapSection) => {
            const openButton = mapSection.querySelector('.button');
            const blockMap = mapSection.querySelector('.making-order__map-block');
            const hideMap = mapSection.querySelector('.order-mobile__map-hide');
    
            openButton.addEventListener("click", () => {
                blockMap.style.height = "420px";
                blockMap.style.opacity = "1";
                blockMap.style.overflow = "hidden";
    
                hideMap.style.display = "block";
            })
    
            hideMap.addEventListener("click", () => {
                blockMap.style.height = "0px";
                blockMap.style.opacity = "0";
                blockMap.style.overflow = "auto";
    
                hideMap.style.display = "none";
            })
        })
    }
  });